Page <span class="text-primary"><strong>{{ current }}</strong> of <strong>{{ total }}</strong></span>
